
/* global gdAlertify */
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from "../config/axiosConfig"; // Asegúrate de tener tu configuración de axios
import BuscarPaciente from "./components/BuscarPaciente";
import Calendario from "./components/Calendario";
import { formatDateTime, formatMonthDate, formatDate, formatSectorLabel } from "../utils/utils";
import { isNullOrUndef } from "chart.js/helpers";
import GdTable from "./components/GdTable";
import MonthInput from "./components/MonthInput";

const ListaVisitas = () => {
    const [pacienteInfo, setPacienteInfo] = useState(null);
    const [visitas, setVisitas] = useState([]);
    const [enfermeria, setEnfermeria] = useState([]);
    const [fechasVisitas, setFechasVisitas] = useState([]);
    const [filtradasVisitas, setFiltradasVisitas] = useState([]);
    const [detalleVisita, setDetalleVisita] = useState(null);
    const [resultados, setResultados] = useState([]);
    const [startMonth, setStartMonth] = useState(new Date().toISOString().slice(0, 7));
    const [loading, setLoading] = useState(false);
    const handleSeleccionaPaciente = async (paciente) => {
        setPacienteInfo(paciente);
    };
    const [modalVisible, setModalVisible] = useState(false);

    const handleVerDetalle = (visita, tipo) => {
        console.log(visita);
        setDetalleVisita(visita);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        setDetalleVisita(null);
    };

    const handleMonthChange = (e) => {
        setStartMonth(e.target.value); // Cambiar el mes seleccionado
    };

    const formatearFechaConMesTexto = (fechaISO) => {
        const meses = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];
        const [anio, mes, dia] = fechaISO.split("-");
        return `${parseInt(dia)}/${meses[parseInt(mes) - 1]}/${anio}`;
    };

    const buscar = async () => {
        gdAlertify.showLoader();
        setLoading(true);

        try {
            const payload = {};
            if (!isNullOrUndef(pacienteInfo)) payload.pacienteID = pacienteInfo.id;
            if (!isNullOrUndef(startMonth)) payload.periodo = startMonth;

            const { data } = await axiosInstance.post("/paciente/visitas", payload);
            const visitas = data.data.visitas || [];
            const enfermeria = data.data.enfermeria || [];
            setVisitas(visitas);
            setEnfermeria(enfermeria);
            // Unificar ambos arrays y normalizar campos
            const listaUnificada = [...visitas, ...enfermeria].map(item => ({
                ...item,
                visitaID: item.visitaID || item.id,
                pacienteID: item.pacienteID || item.paciente_id,
                usuarioID: item.usuarioID || item.usuario_id,
                fecha_visita: item.fecha_visita,
                tipo_visita: item.tipo_visita || 2, // 2 = Enfermería si no está definido
                nombre: item.nombre || "",
                apellido: item.apellido || "",
                nombre_paciente: item.nombre_paciente || "",
                apellido_paciente: item.apellido_paciente || "",
                diagnostico: item.diagnostico || item.antecedentesMedicos || "",
                estado_salud: item.estado_salud || item.estadoSalud || "",
                estado_cognitivo: item.estado_cognitivo || item.estadoCognitivo || "",
                habla: item.habla || item.capacidadHablar || "",
                movimiento: item.movimiento || item.capacidadMoverse || "",
                antecedentes_medicos: item.antecedentes_medicos || item.antecedentesMedicos || "",
                examen_fisico: item.examen_fisico || item.examenFisico || "",
                medicamento_horarios: item.medicamento_horarios || item.medicamentos || "",
                rutina: item.rutina || item.rutinas || "",
                plan_atencion: item.plan_atencion || item.planAtencion || "",
                observacion: item.observacion || item.observacionesSugerencias || item.observacionesPaciente || "",
                usuario_visita: item.usuario_visita || "",
                tipo: item.tipo_visita === 2 ? 'Enfermería' : 'Visita',
                nombre_auxiliar_visita: item.nombre_auxiliar_visita || "",
                observacion_auxiliar: item.observacion_auxiliar || "",
            }));

            setVisitas(listaUnificada);
            setFiltradasVisitas(listaUnificada);
            setFechasVisitas(listaUnificada.map(v => v.fecha_visita));
            console.log(filtradasVisitas);
        } catch (error) {
            console.error("Error al obtener los datos: ", error);
            setVisitas([]);
            setFiltradasVisitas([]);
        } finally {
            gdAlertify.hideLoader();
            setLoading(false);
        }
    };

    useEffect(() => {
        buscar();
    }, [resultados]);

    const columns = [
        {
            title: "Fecha",
            name: "fecha_visita",
            render: (row) => (
                formatDate(row.fecha_visita)
            )
        },
        {
            title: "Tipo de Visita",
            name: "tipo_visita",
            render: (row) => (
                row.tipo_visita == 1 ? "Visita" : "Enfermeria"
            )
        },
        {
            title: "Paciente",
            name: "nombre_paciente",
            render: (row) => {
                return row.nombre_paciente + ' ' + row.apellido_paciente;
            }

        },
        {
            title: "Enfermera/o",
            name: "nombre",
            render: (row) => {
                return row.nombre + ' ' + row.apellido;
            }
        },
        {
            title: "Sector",
            name: "sector",
            render: (row) => formatSectorLabel(row.sector),
        },
        {
            title: "Acciones",
            name: "acciones",
            render: (row) => (
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => handleVerDetalle(row, row.tipo_visita)}
                >
                    Ver Detalle
                </button>
            )
        }
    ];

    const renderDetalle = (titulo, valor) => {
        // if (valor) {
        return (
            <div key={titulo} className="mb-3 col-6">
                <h5>{titulo}</h5>
                <p>{valor}</p>
            </div>
        );
        // }
        // return null; // Si el valor es vacío o nulo, no lo renderiza
    };

    return (
        <div className="container-fluid mt-5">
            <div className="card p-4">
                <h3 className="mb-4">Visitas</h3>
                <div className="mb-3">
                    <div className="row">
                        <div className="border p-4 mb-4 col-12">
                            <div className="row g-3 d-flex justify-content-between">
                                <div className="col-md-6">
                                    <BuscarPaciente onSelect={handleSeleccionaPaciente} onClear={handleSeleccionaPaciente} conPaciente={true} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label fw-bold">Periodo</label>
                                    <MonthInput
                                        className="form-control"
                                        placeholder="Mes de inicio"
                                        value={startMonth}
                                        onChange={handleMonthChange} // Cambiar mes
                                    />
                                </div>
                                <div className="col-md-12 d-flex justify-content-center">
                                    <button className="btn btn-primary" onClick={buscar} disabled={loading}>
                                        {loading ? "Buscando..." : "Buscar"}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <GdTable
                            columns={columns}
                            data={filtradasVisitas}
                            defaultItemsPerPage={100}
                            itemsPerPageOptions={[5, 10, 25, 50, 100]}
                            initialSort={[1, "desc"]}
                            loading={loading}
                            exportFilename="lista-visitas.xlsx"
                        />
                        {modalVisible && detalleVisita && (
                            <div className="modal modal-xl d-block" tabIndex="-1">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <div className="bg-white p-6 rounded shadow-xl w-full max-w-xl">
                                                <h2 className="text-xl font-bold mb-4">
                                                    Detalle de Visita #{detalleVisita.visitaID}
                                                </h2>
                                                <div className="row">
                                                    {detalleVisita.tipo_visita == 1 ? (
                                                        <>
                                                            {renderDetalle('Enfermero/a Visita', detalleVisita.usuario_visita)}
                                                            {renderDetalle('Nombre Paciente', detalleVisita.nombre_paciente + ' ' + detalleVisita.apellido_paciente)}
                                                            {renderDetalle('Fecha de la Visita', formatDate(detalleVisita.fecha_visita))}
                                                            {renderDetalle('Mes de la Visita', formatMonthDate(detalleVisita.fecha_visita))}
                                                            {renderDetalle('Tipo de Visita', detalleVisita.tipo_visita === 1 ? 'Presencial' : 'Telefónico')}
                                                            {renderDetalle('Antecedentes Médicos', detalleVisita.antecedentes_medicos)}
                                                            {renderDetalle('Diagnóstico', detalleVisita.diagnostico)}
                                                            {renderDetalle('Estado Cognitivo', detalleVisita.estado_cognitivo)}
                                                            {renderDetalle('Estado de Salud', detalleVisita.estado_salud)}
                                                            {renderDetalle('Evolución', detalleVisita.examen_fisico)}
                                                            {renderDetalle('Habla', detalleVisita.habla)}
                                                            {renderDetalle('Medicamentos y Horarios', detalleVisita.medicamento_horarios)}
                                                            {renderDetalle('Movimiento', detalleVisita.movimiento)}
                                                            {renderDetalle('Observación', detalleVisita.observacion)}
                                                            {renderDetalle('Plan de Atención', detalleVisita.plan_atencion)}
                                                            {renderDetalle('Rutina', detalleVisita.rutina)}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {renderDetalle('Enfermero/a Visita', detalleVisita.nombre + ' ' + detalleVisita.apellido)}
                                                            {renderDetalle('Nombre Paciente', detalleVisita.nombre_paciente + ' ' + detalleVisita.apellido_paciente)}
                                                            {renderDetalle('Fecha de Registro', formatDate(detalleVisita.fecha_visita))}
                                                            {renderDetalle('Mes de Registro', formatMonthDate(detalleVisita.fecha_visita))}
                                                            {renderDetalle('Estado de Cama', detalleVisita.estadoCama)}
                                                            {renderDetalle('Estado de Casa', detalleVisita.estadoCasa)}
                                                            {renderDetalle('Estado Cognitivo', detalleVisita.estadoCognitivo)}
                                                            {renderDetalle('Estado de Salud', detalleVisita.estadoSalud)}
                                                            {renderDetalle('Estado de Habitación', detalleVisita.estadoHabitacion)}
                                                            {renderDetalle('Evaluación Domicilio', detalleVisita.evaluacionDomicilio)}
                                                            {renderDetalle('Evolución', detalleVisita.examenFisico)}
                                                            {renderDetalle('Asistencia Adicional', detalleVisita.asistenciaAdicional)}
                                                            {renderDetalle('Lenguaje', detalleVisita.capacidadHablar)}
                                                            {renderDetalle('Movilidad', detalleVisita.capacidadMoverse)}
                                                            {renderDetalle('Medicamentos', detalleVisita.medicamentos)}
                                                            {renderDetalle('Necesidades Especiales', detalleVisita.necesidadesEspeciales)}
                                                            {renderDetalle('Plan de Atención', detalleVisita.planAtencion)}
                                                            {renderDetalle('Riesgos', detalleVisita.riesgos)}
                                                            {renderDetalle('Rutinas', detalleVisita.rutinas)}
                                                        </>
                                                    )}

                                                    {detalleVisita.nombre_auxiliar_visita && renderDetalle('Auxiliar', detalleVisita.nombre_auxiliar_visita)}
                                                    {detalleVisita.observacion_auxiliar && renderDetalle('Observación Auxiliar', detalleVisita.observacion_auxiliar)}
                                                </div>
                                                <button
                                                    onClick={cerrarModal}
                                                    className="mt-4 px-4 py-2 bg-gray-600 rounded"
                                                >
                                                    Cerrar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};


export default ListaVisitas;
